module.exports = __webpack_public_path__ + "static/img/line.544f299.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/line.png
// module id = pbcx
// module chunks = 7